import React from 'react'
import CamionesEnCircuitoPorExpCereal from './CamionesEnCircuitoPorExpCereal'
import TablaCircuitoCerealPesoTotal from './TablaCircuitoCerealPesoTotal'

function TablasCircuitoTotalizadores () {
  return (
    <>
      <CamionesEnCircuitoPorExpCereal />
      <TablaCircuitoCerealPesoTotal />
    </>
  )
}

export default TablasCircuitoTotalizadores
